// Base URL server AgentX (Cloudflare). Đổi qua REACT_APP_API_BASE khi deploy.
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.ractest.shop'
    : 'https://api-staging.ractest.shop');
